import { Logo } from '../components/ui/bits.jsx';
import { t } from '../i18n/index.js';

/** Prvi zaslon: med nalaganjem, in ob napaki, ki app ustavi. */
export function Splash({ error, onRetry, onSignOut }) {
  return (
    <div
      className="stack"
      style={{
        minHeight: '100dvh',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--s-6)',
        textAlign: 'center',
      }}
    >
      <Logo height={72} />

      {error ? (
        <>
          <h1 className="t-xl">{t('Nekaj je šlo narobe')}</h1>
          <p className="t-md t-dim" style={{ maxWidth: '38ch' }}>
            {error}
          </p>
          <div className="row" style={{ marginTop: 'var(--s-2)' }}>
            <button className="btn btn--primary" onClick={onRetry}>
              {t('Poskusi znova')}
            </button>
            <button className="btn btn--ghost" onClick={onSignOut}>
              {t('Odjava')}
            </button>
          </div>
        </>
      ) : (
        <p className="t-md t-dimmer" role="status">
          {t('Nalagam …')}
        </p>
      )}
    </div>
  );
}
